import { router } from '@inertiajs/react';
import { Check, ChevronDown } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface TrackFilterProps {
  tracks: string[];
  selected: string[];
  votePath: string;
}

export function TrackFilter({ tracks, selected, votePath }: TrackFilterProps) {
  const updateTracks = (next: string[]) => {
    const params = new URLSearchParams(window.location.search);
    params.delete('tracks');
    for (const name of next) {
      params.append('tracks', name);
    }
    const qs = params.toString();
    router.visit(qs ? `${votePath}?${qs}` : votePath, {
      preserveScroll: true,
      preserveState: true,
    });
  };

  const toggle = (name: string) => {
    if (selected.includes(name)) {
      updateTracks(selected.filter((n) => n !== name));
    } else {
      updateTracks([...selected, name]);
    }
  };

  const clear = () => updateTracks([]);

  const label =
    selected.length === 0
      ? 'Todos los tracks'
      : selected.length === 1
        ? selected[0]
        : `${selected.length} tracks`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-2 border-2 border-primary/30 bg-background px-4 py-2 font-sans text-primary text-sm transition-all hover:border-primary"
        >
          <span>{label}</span>
          <ChevronDown className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-64 border-2 border-primary/30 bg-background p-0"
      >
        <div className="flex flex-col">
          <button
            type="button"
            onClick={clear}
            className={cn(
              'flex items-center justify-between border-primary/20 border-b px-4 py-2 text-left font-sans text-primary text-sm transition-colors hover:bg-primary/5',
              selected.length === 0 && 'font-bold',
            )}
          >
            <span>Todos</span>
            {selected.length === 0 && <Check className="h-4 w-4" />}
          </button>
          {tracks.map((name) => {
            const checked = selected.includes(name);
            return (
              <button
                key={name}
                type="button"
                onClick={() => toggle(name)}
                className={cn(
                  'flex items-center justify-between px-4 py-2 text-left font-sans text-primary text-sm transition-colors hover:bg-primary/5',
                  checked && 'bg-primary/5 font-bold',
                )}
              >
                <span>{name}</span>
                {checked && <Check className="h-4 w-4" />}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
